import { useState, useEffect } from 'react';

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1500);
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 4000);
    }, 3000);
    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
    >
      {/* Tooltip */}
      {showTooltip && (
        <div className="bg-white text-gray-900 text-xs font-semibold px-4 py-2.5 rounded-xl shadow-xl whitespace-nowrap animate-bounce-once">
          Hemen yazın, yanıt verelim! 👋
          <div className="absolute bottom-[-6px] right-5 w-3 h-3 bg-white rotate-45" />
        </div>
      )}

      {/* Button */}
      <a
        href="https://wa.me/905402470724?text=Merhaba%2C%20Smart%20Hizmet%20Platform%20Paketleri%20hakk%C4%B1nda%20g%C3%B6r%C3%BC%C5%9Fmek%20istiyorum."
        target="_blank"
        rel="noopener noreferrer"
        className="relative w-14 h-14 flex items-center justify-center rounded-full bg-[#25d366] shadow-lg hover:scale-110 transition-transform duration-200 cursor-pointer"
      >
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25d366] animate-ping opacity-30" />
        <i className="ri-whatsapp-line text-white text-2xl relative z-10"></i>
      </a>
    </div>
  );
}
